// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IPVMobile_container__43V0Q {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fff5f5 0%, #fff0f0 50%, #fff 100%);
  padding: 20px;
  font-family: 'Segoe UI', Arial, sans-serif;
}

.IPVMobile_card__nKVg6 {
  background: white;
  border-radius: 20px;
  padding: 32px 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 10px 40px rgba(248, 106, 110, 0.15);
  border: 1px solid #ffd6d7;
}

.IPVMobile_header__X\\+N90 {
  text-align: center;
  margin-bottom: 28px;
}

.IPVMobile_headerIcon__tTH1L {
  font-size: 48px;
  margin-bottom: 12px;
}

.IPVMobile_title__HyFTT {
  font-size: 22px;
  font-weight: 700;
  color: #2d2d2d;
  margin: 0 0 8px;
}

.IPVMobile_subtitle__dH3oh {
  font-size: 14px;
  color: #888;
  margin: 0;
}

.IPVMobile_steps__PzWTS {
  background: #fff8f8;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 24px;
}

.IPVMobile_step__Q\\+coP {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.IPVMobile_stepIcon__AfdN8 {
  font-size: 24px;
  flex-shrink: 0;
  margin-top: 2px;
}

.IPVMobile_stepTitle__6n\\+8h {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.IPVMobile_stepDesc__tRPuE {
  font-size: 13px;
  color: #888;
  line-height: 1.4;
}

.IPVMobile_stepArrow__bq-1R {
  text-align: center;
  font-size: 18px;
  color: #f86a6e;
  margin: 8px 0;
  padding-left: 34px;
}

.IPVMobile_button__TKptZ {
  width: 100%;
  padding: 16px;
  background: linear-gradient(to bottom, #f8777b, #f73439);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
  letter-spacing: 0.3px;
}

.IPVMobile_button__TKptZ:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
}

.IPVMobile_button__TKptZ.IPVMobile_loading__EXD\\+v,
.IPVMobile_button__TKptZ:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.IPVMobile_hint__8LKHu {
  font-size: 12px;
  color: #aaa;
  text-align: center;
  margin-top: 16px;
  line-height: 1.5;
}

.IPVMobile_errorPage__WFyH7 {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff5f5;
  padding: 20px;
  text-align: center;
  font-family: 'Segoe UI', Arial, sans-serif;
}

.IPVMobile_errorCard__laVl3 {
  background: white;
  border-radius: 16px;
  padding: 32px 24px;
  max-width: 360px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.IPVMobile_errorIcon__yC7Sy {
  font-size: 48px;
  margin-bottom: 16px;
}

.IPVMobile_errorCard__laVl3 h2 {
  color: #e74c3c;
  margin: 0 0 12px;
}

.IPVMobile_errorCard__laVl3 p {
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.IPVMobile_loader__sdy8q {
  width: 40px;
  height: 40px;
  border: 4px solid #ffd6d7;
  border-top-color: #f73439;
  border-radius: 50%;
  animation: IPVMobile_spin__aA8rh 0.8s linear infinite;
  margin: 0 auto 16px;
}

@keyframes IPVMobile_spin__aA8rh {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/IPVMobile.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uEAAuE;EACvE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wDAAwD;EACxD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qDAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #fff5f5 0%, #fff0f0 50%, #fff 100%);\n  padding: 20px;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n\n.card {\n  background: white;\n  border-radius: 20px;\n  padding: 32px 24px;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: 0 10px 40px rgba(248, 106, 110, 0.15);\n  border: 1px solid #ffd6d7;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.headerIcon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #2d2d2d;\n  margin: 0 0 8px;\n}\n\n.subtitle {\n  font-size: 14px;\n  color: #888;\n  margin: 0;\n}\n\n.steps {\n  background: #fff8f8;\n  border-radius: 14px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.step {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.stepIcon {\n  font-size: 24px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.stepTitle {\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 2px;\n}\n\n.stepDesc {\n  font-size: 13px;\n  color: #888;\n  line-height: 1.4;\n}\n\n.stepArrow {\n  text-align: center;\n  font-size: 18px;\n  color: #f86a6e;\n  margin: 8px 0;\n  padding-left: 34px;\n}\n\n.button {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(to bottom, #f8777b, #f73439);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 17px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n  letter-spacing: 0.3px;\n}\n\n.button:hover:not(:disabled) {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.button.loading,\n.button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.hint {\n  font-size: 12px;\n  color: #aaa;\n  text-align: center;\n  margin-top: 16px;\n  line-height: 1.5;\n}\n\n.errorPage {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #fff5f5;\n  padding: 20px;\n  text-align: center;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n\n.errorCard {\n  background: white;\n  border-radius: 16px;\n  padding: 32px 24px;\n  max-width: 360px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n}\n\n.errorIcon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.errorCard h2 {\n  color: #e74c3c;\n  margin: 0 0 12px;\n}\n\n.errorCard p {\n  color: #666;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.loader {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #ffd6d7;\n  border-top-color: #f73439;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 16px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IPVMobile_container__43V0Q`,
	"card": `IPVMobile_card__nKVg6`,
	"header": `IPVMobile_header__X+N90`,
	"headerIcon": `IPVMobile_headerIcon__tTH1L`,
	"title": `IPVMobile_title__HyFTT`,
	"subtitle": `IPVMobile_subtitle__dH3oh`,
	"steps": `IPVMobile_steps__PzWTS`,
	"step": `IPVMobile_step__Q+coP`,
	"stepIcon": `IPVMobile_stepIcon__AfdN8`,
	"stepTitle": `IPVMobile_stepTitle__6n+8h`,
	"stepDesc": `IPVMobile_stepDesc__tRPuE`,
	"stepArrow": `IPVMobile_stepArrow__bq-1R`,
	"button": `IPVMobile_button__TKptZ`,
	"loading": `IPVMobile_loading__EXD+v`,
	"hint": `IPVMobile_hint__8LKHu`,
	"errorPage": `IPVMobile_errorPage__WFyH7`,
	"errorCard": `IPVMobile_errorCard__laVl3`,
	"errorIcon": `IPVMobile_errorIcon__yC7Sy`,
	"loader": `IPVMobile_loader__sdy8q`,
	"spin": `IPVMobile_spin__aA8rh`
};
export default ___CSS_LOADER_EXPORT___;
